import { createSlice } from "@reduxjs/toolkit";
import { allApi } from "../../../utils/config";
import customaxios from "../../services/axios";
import { eccnClassificationInitialState } from "../../../utils/const";

export const callEccnClassificationAPI = (payload, submit, upgradePopup) => async (dispatch, getState) => {
  try {
    dispatch(
      setLoadingState({
        isLoading: true,
      })
    );
    const res = await customaxios({
      method: "POST",
      url: allApi.eccnClassificationResults,
      data: payload,
    });
    const currentData = res?.data?.data;
    if (res && res.data && res.data?.credit_expired && res.data.credit_expired !== "" && res.data.credit_expired === true) {
      upgradePopup(true);
    } else {
      upgradePopup(false);

      dispatch(
        setEccnQuery({
          searchQuery: {},
          searchResult: [],
        })
      );

      setTimeout(
        () =>
          dispatch(
            setEccnQuery({
              searchQuery: payload,
              searchResult: [...currentData],
            })
          ),
        1
      );
    }
  } catch (error) {
    console.log("Error ", error);
  }

  setTimeout(
    () =>
      dispatch(
        setLoadingState({
          isLoading: false,
        })
      ),
    2
  );
};

const slice = createSlice({
  name: "eccnClassification",
  initialState: eccnClassificationInitialState,
  reducers: {
    setLoadingState: (state, action) => {
      state.isLoading = action?.payload?.isLoading;
    },
    setShowMatchType: (state, action) => {
      state.showMatchType = action?.payload?.showMatchType;
    },
    setEccnQuery: (state, action) => {
      state.eccnState.searchQuery = action?.payload?.searchQuery;
      state.eccnState.searchResult = action?.payload?.searchResult;
    },
    setEccnFormState: (state, action) => {
      state.eccnFormState = action.payload;
    },
    resetEccn: (state, action) => {
      state.eccnState.searchQuery = action?.payload?.searchQuery;
      state.eccnState.searchResult = action?.payload?.searchResult;
      state.eccnFormState = action?.payload?.eccnFormState;
    },
  },
});

export const { setLoadingState, setShowMatchType, setEccnQuery, setEccnFormState, resetEccn } = slice.actions;
export default slice.reducer;
